function DropdownListItemText({ text }) {
  return <div className="list-item-text">{text}</div>;
}

export default DropdownListItemText;
